import React, { Component } from "react";
import PedidoDevolucaoMaterial from "../PedidoDevolucaoMaterial";

export default class DevolucaoMaterial extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <PedidoDevolucaoMaterial tipoPedido={1} {...this.props} />;
  }
}
